import React, { Component } from 'react';
import './App.css';

var addresses = [];
var cards = [];
var web_title = ["shopping.com", "headphone.com", "furniture.com"];

class App extends Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    this.state = {
      stage: "init",
      saved: false,
      title: "shopping.com",
      website: "1",
    }
  }

  handler(e) {
    e.preventDefault()
    this.setState({
      stage: "processing",
      saved: true,
    })
  }

  processing = () => {
    var temp = this;
    setTimeout(function(){
      document.getElementById('Panel').classList.add("done");
    },2000);
    setTimeout(function(){
      document.getElementById('Panel').classList.remove("active");
    },3000);
    setTimeout(function(){
      temp.setState({
        stage: "done"
      });
    },3300);
  };

  init = (number) => {
    switch(number) {
      case 1:
        this.setState({
          stage: "init",
          title: "shopping.com",
          website: "1"    
        });
        break;
      case 2:
        this.setState({
          stage: "init",
          title: "headphone.com",
          website: "2"    
        });
        break;
      case 3:
        this.setState({
          stage: "init",
          title: "furniture.com",
          website: "3"    
        });
        break;
      default:
        return null;
    }
  };

  website = (done) => {
    switch(this.state.website) {
      case "1":
        if(done) return (<Website website="done1"/>);
        else return (<Website website="init1"/>);
      case "2":
        if(done) return (<Website website="done2"/>);
        else return (<Website website="init2"/>);
      case "3":
        if(done) return (<Website website="done3"/>);
        else return (<Website website="init3"/>);
      default:
        return true;
    }
  };

  price = () => {
    switch(this.state.website) {
      case "1":
        return (<Price website="1"/>);
      case "2":
        return (<Price website="2"/>);
      case "3":
        return (<Price website="3"/>);
      default:
        return true;
    }
  };

  render() {
    switch(this.state.stage){
      case "init":
      return (
        <div className="App">          
          <div id="Panel">
            <div className="container">
              {this.price()}
              <div className="payment-bottom-section">
                <Payment handler={this.handler} saved={this.state.saved} ref="payment" />
              </div>
            </div>
          </div>
          <div className="background"></div>
          {this.website(false)}
        </div>
      );
      case "processing":
      this.processing();
      return (
        <div className="App">
          <div id="Panel">
            <div className="container">
              <div className="payment-top-section">
                <div className="title">
                  <h1>Your Order</h1>
                  <p>Pay to {this.state.title}</p>
                </div>
                <div id="processing"></div>
                <div>(Do not close browser)</div>
              </div>  
            </div>
          </div>
          <div className="background"></div>
          {this.website(false)}
        </div>
      );
      case "done":
      return (
        <div className="App">
          {this.website(true)}
          <div id="Website-Panel">
            <p onClick={ (e) => {this.init(1)}}>Visit Website 1</p>
            <p onClick={ (e) => {this.init(2)}}>Visit Website 2</p>
            <p onClick={ (e) => {this.init(3)}}>Visit Website 3</p>
          </div>
        </div>
      );
      default:
      return true;
    }
  }
}

class Website extends Component {
  constructor(props) {
    super(props);
  }

  // Functions
  openPanel = () => {
    document.getElementById('Panel').classList.add("active");
    document.getElementById('Panel').classList.remove("done");
  };

  render() {
    switch(this.props.website){
      case "init1":
        return (
          <div className="Website">
            <section id="header">
              <div>
                <h1><a href=".">Shopping.com</a></h1>
                <div id="web-links">
                  <a>Sign in</a>
                  <a>My Account</a>
                </div>
              </div>
            </section>
            <div id="web-tabs">
              <ul>
                <li>new in</li>
                <li>men</li>
                <li>women</li>
                <li>kids</li>
                <li>beauty</li>
                <li>sale</li>
                <li>lookbook</li>
              </ul>
            </div>
            <section id="content">
              <h2>Shopping Cart</h2>
              <div id="shopping-cart">
                <div>
                  <div id="product-details">
                    <label>product details</label>
                    <label>quantity</label>
                    <label>price</label>
                    <label>total</label>
                  </div>
                  <div className="items" id="item-1">
                    <div>
                      <label>Sports shoes</label>
                      <label>Color: Black</label>
                      <label>Size: 35</label>
                    </div>
                    <div>
                      <select className="input">
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                    <p>$100.00</p>
                    <p>$100.00</p>
                  </div>
                  <div className="items" id="item-2">
                    <div>
                      <label>Summer sandles</label>
                      <label>Color: Black</label>
                      <label>Size: 35</label>
                    </div>
                    <div>
                      <select className="input">
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                    <p>$90.00</p>
                    <p>$90.00</p>
                  </div>
                </div>
                <div id="order-summary">
                  <h3>order summary</h3>
                  <div id="order-list">
                    <div id="order-items">
                      <p>Sports shoes</p>
                      <p>Summer sandles</p>
                      <p>Shipping fee</p>
                      <p>Tax</p>
                      <p className="order-total">Total</p>
                    </div>
                    <div id="order-prices">
                      <p>$100.00</p>
                      <p>$90.00</p>
                      <p>$10.00</p>
                      <p>$20.00</p>
                      <p className="order-total">$220.00</p>
                    </div>
                  </div>
                  <button className="checkout" onClick={this.openPanel}>Checkout</button>
                </div>
              </div>
            </section>
          </div>
        );
      case "done1":
        return (
          <div className="Website">
            <section id="header">
              <div>
                <h1><a href=".">Shopping.com</a></h1>
                <div id="web-links">
                  <a>Sign in</a>
                  <a>My Account</a>
                </div>
              </div>
            </section>
            <div id="web-tabs">
              <ul>
                <li>new in</li>
                <li>men</li>
                <li>women</li>
                <li>kids</li>
                <li>beauty</li>
                <li>sale</li>
                <li>lookbook</li>
              </ul>
            </div>
            <section id="content">
              <h2>Thanks you for your order</h2>
              <p>Your order number is: 57684267722</p>
              <a>View the receipt</a>
              <a>Print receipt</a>
              <a>Keep shopping</a>
            </section>
          </div>
        );  
      case "init2":
        return(
          <div className="Website" id="Website-2">
            <section id="header">
              <div>
                <h1>Headphone.com</h1>
                <div id="web-links">
                  <a>headphone</a>
                  <a>speaker</a>
                  <a>better with headphone.com</a>
                  <a>local shop</a>
                  <a>support</a>
                </div>
              </div>
            </section>
            <section id="content">
              <h2>Items in your Cart</h2>
              <div id="shopping-cart">
                <div>
                  <label>Comfort 77 Headphone</label>
                  <label>Black</label>
                  <select className="input">
                    <option selected>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                  </select>
                </div>
                <div>
                  <p>$230.00</p>
                </div>
              </div>
              <div id="order-summary">
                <div>
                  <div id="order-list">
                    <div id="order-items">
                      <p>Cart Subtotal</p>
                      <p>Tax</p>
                      <p>Shipping Fee</p>
                      <p className="order-total">Total</p>
                    </div>
                    <div id="order-prices">
                      <p>$230.00</p>
                      <p>$23.00</p>
                      <p>$10.00</p>
                      <p className="order-total">$263.00</p>
                    </div>
                  </div>
                  <button className="checkout" onClick={this.openPanel}>Checkout</button>
                </div>
              </div>
            </section>
          </div>
        );
      case "done2":
        return(
          <div className="Website" id="Website-2">
            <section id="header">
              <div>
                <h1>Headphone.com</h1>
                <div id="web-links">
                  <a>headphone</a>
                  <a>speaker</a>
                  <a>better with headphone.com</a>
                  <a>local shop</a>
                  <a>support</a>
                </div>
              </div>
            </section>
            <section id="content">
              <h2>Thanks you for your order</h2>
              <p>Your order number is: 57684267722</p>
              <a>View the receipt</a>
              <a>Print receipt</a>
              <a>Keep shopping</a>
            </section>
          </div>
        );
      case "init3":
        return(
          <div className="Website" id="Website-3">
            <section id="header">
              <div>
                <h1><a href=".">Furniture.</a></h1>
                <div id="web-links">
                  <a>By Category</a>
                  <a>By Room</a>
                  <a>By Designer</a>
                  <a>Textiles</a>
                  <a>Inspiration</a>
                </div>
              </div>
            </section>
            <section id="content">
              <h2>Shopping Cart</h2>
              <p> {'<<'} Go back to shopping</p>
              <div id="shopping-cart">
                <div>
                  <div id="product-details">
                    <label>Furnitures, Accessories and Leather</label>
                  </div>
                  <div className="items" id="item-1">
                    <div>
                      <label>Barcelona Chair</label>
                      <label>Ludwig Mies van der Rohe</label>
                      <label>$1500</label>
                      <label>Quantity</label>
                      <select>
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                  </div>
                  <div className="items" id="item-2">
                    <div>
                      <label>Basel Chair</label>
                      <label>Jasper Morrison</label>
                      <label>$1400</label>
                      <label>Quantity</label>
                      <select>
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div id="order-summary">
                  <h3>order summary</h3>
                  <div id="order-list">
                    <div id="order-items">
                      <p>Barcelona Chair X1</p>
                      <p>Basel Chair X1</p>
                      <p>Tax</p>
                      <p>Shipping Fee</p>
                      <p className="order-total">Subtotal</p>
                    </div>
                    <div id="order-prices">
                      <p>$1500.00</p>
                      <p>$1400.00</p>
                      <p>$100.00</p>
                      <p>$10.00</p>
                      <p className="order-total">$3010.00</p>
                    </div>
                  </div>
                  <button className="checkout" onClick={this.openPanel}>Proceed to Checkout</button>
                </div>
              </div>
            </section>
          </div>
        );
      case "done3":
        return(
          <div className="Website" id="Website-3">
            <section id="header">
              <div>
                <h1><a href=".">Furniture.</a></h1>
                <div id="web-links">
                  <a>By Category</a>
                  <a>By Room</a>
                  <a>By Designer</a>
                  <a>Textiles</a>
                  <a>Inspiration</a>
                </div>
              </div>
            </section>
            <section id="content">
              <h2>Thanks you for your order</h2>
              <p>Your order number is: 57684267722</p>
              <a>View the receipt</a>
              <a>Print receipt</a>
              <a>Keep shopping</a>
            </section>
          </div>
        );
      default:
        return true;
    }
  }
}

class Price extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: "10",
    }
  }

  toggleItems() {
    document.getElementById('items').classList.toggle("open");
    document.querySelector('[name="cancel-button"]').classList.toggle("open");
  };

  priceChange = (e) => {
    this.setState({price: e.target.value});
  };

  render() {
    var items = null;
    var total = 0;

    switch(this.props.website){
      case "1":
        total = 210;
        items = (
        <div id="items">
          <div><label id="toggle" onClick={this.toggleItems}>All Items</label><label>$210.00</label></div>
          <ul id="toggle-list">
            <li><label>Sport Shoes</label><label>$100.00</label></li>
            <li><label>Summer Sandles</label><label>$90.00</label></li>
            <li><label>Tax</label><label>$20.00</label></li>
          </ul>
        </div>);
        break;
      case "2":
        total = 253;
        items = (
        <div id="items">
          <div><label id="toggle" onClick={this.toggleItems}>All Items</label><label>$253.00</label></div>
          <ul id="toggle-list">
            <li><label>Comfort 77 Headphone</label><label>$230.00</label></li>
            <li><label>-</label></li>
            <li><label>Tax</label><label>$23.00</label></li>
          </ul>
        </div>);
        break;
      case "3":
        total = 3000;
        items = (
        <div id="items">
          <div><label id="toggle" onClick={this.toggleItems}>All Items</label><label>$3000.00</label></div>
          <ul id="toggle-list">
            <li><label>Barcelona Chair</label><label>$1500.00</label></li>
            <li><label>Basel Chair</label><label>$1400.00</label></li>
            <li><label>Tax</label><label>$100.00</label></li>
          </ul>
        </div>);
        break;
      default:
        return true;
    }

    return (
      <div className="payment-top-section">
        <div className="title">
          <h1>Your Order</h1>
          <p>Pay to {web_title[parseInt(this.props.website)-1]}</p>
        </div>
        <div className="price" id="price">
          {items}
          <div id="shipping">
            <div>
              <label>Shipping:</label>
              <form>
                <select name="shipping" onChange={this.priceChange}>
                  <option value="10"> Standard $10.00 </option>
                  <option value="20"> Express $20.00 </option>
                  <option value="30"> Premium $30.00 </option>
                </select>
              </form>
            </div>
            <label>${parseInt(this.state.price, 10).toFixed(2)}</label>
          </div>
          <p id="total">Total(US)<span>${(parseInt(this.state.price, 10) + total).toFixed(2)}</span></p>
        </div>
      </div>
    );
  }
}

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: "1",
      type: "",
      check: false,
      cont: ["disabled", "disabled"]
    };
    this.detail = {
      name: "",
      address: "",
      city: "",
      state: "",
      country: "",
      postal: "",
      phone: "",
      email: "",
      info: "",
      save_address: false
    };
    this.card = {
      name: "",
      number: "",
      number_blocked: "",
      month: "",
      year: "",
      date: "",
      save_card: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(document.querySelector('[name="name"]')!==null) {
      document.querySelector('[name="name"]').focus();
    }
    if(document.querySelector('[name="card-name"]')!==null) {
      document.querySelector('[name="card-name"]').focus();
    }
    if(document.querySelector('[name="card-cvv"]')!==null) {
      document.querySelector('[name="card-cvv"]').focus();
    }
  }

  closePanel = () => {
    document.getElementById('Panel').classList.remove("active");
    if(document.getElementById('items').classList.contains("open")){
      document.getElementById('items').classList.remove("open");
    }
    // var card = document.getElementById('visa');
    // var btn = document.getElementById('continue');
    // card.classList.remove('active');
    // btn.classList.add('disabled');
    var temp = this;
    setTimeout(function(){
      temp.setState({
        stage: "1",
        type: "",
        check: false,
        cont: ["disabled", "disabled"]
      });
      temp.detail = {
        name: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postal: "",
        phone: "",
        email: "",
        info: "",
        save_address: false
      };
      temp.card = {
        name: "",
        number: "",
        number_blocked: "",
        month: "",
        year: "",
        date: "",
        save_card: false
      }
    }, 500);
  };

  jumpStage = (new_stage) => {
    if(document.getElementById('items').classList.contains("open")){
      document.getElementById('items').classList.remove("open");
    }
    this.setState({stage: "7"}); 
  };

  nextStage = () => {
    if(document.getElementById('items').classList.contains("open")){
      document.getElementById('items').classList.remove("open");
    }
    
    if(this.state.stage === "1" && this.props.saved) {
      if(cards.length > 1) this.setState({stage: "9"}); 
      else this.setState({stage: "6"}); 
    }
    else {
      var i = parseInt(this.state.stage,10)+1;
      this.setState({stage: i.toString()}); 
    }
  };

  prevStage = () => {
    if(document.getElementById('items').classList.contains("open")){
      document.getElementById('items').classList.remove("open");
    }
    if((this.state.stage === "6" || this.state.stage === "9") && this.props.saved) {
      this.setState({stage: "1"}); 
    }
    else {
      var i = parseInt(this.state.stage,10)-1;
      this.setState({stage: i.toString()}); 
    }
    if(this.state.stage === "3") addresses.pop();
    if(this.state.stage === "4") cards.pop();
  };

  checkForm() {
    console.log("check-form");
    var form = document.forms["info"];
    var btn = document.getElementById('continue');
    if(form.checkValidity()) {
      btn.disabled = false;
      btn.classList.remove('disabled');
    } else {
      btn.disabled = true;
    }
  };

  cvvReset() {
    var cvv = document.querySelector('[name="card-cvv"]');
    cvv.value = "";
    document.querySelector('[name="card-cvv"]').focus();
  }

  checkDropdown() {
    var cvv = document.querySelector('[name="card-cvv"]');
    var btn = document.getElementById('continue');
    var value = document.querySelector('[name="card-dropdown"]').selectedIndex;
    if(value === cards.length-1) {
      document.querySelector('[name="card-cvv"]').classList.add('none');
      btn.disabled = false;
      btn.classList.remove('disabled');
      console.log("###");
    } else {
      document.querySelector('[name="card-cvv"]').classList.remove('none');
      document.querySelector('[name="card-cvv"]').focus();
    
      if(cvv.checkValidity()) {
        btn.disabled = false;
        btn.classList.remove('disabled');
      } else {
        btn.disabled = true;
      }
    }
  };

  checkCVV() {
    console.log("card-cvv");
    var cvv = document.querySelector('[name="card-cvv"]');
    var btn = document.getElementById('continue');
    if(cvv.checkValidity()) {
      btn.disabled = false;
      btn.classList.remove('disabled');
    } else {
      btn.disabled = true;
    }
  }

  check = (e) => {  
    var label = e.target;
    if(label.previousSibling !== null) {
      if(label.previousSibling.checked) {
        label.previousSibling.checked = false;
        this.setState({check: false});
      }
      else {
        label.previousSibling.checked = true;
        this.setState({check: true});
      }
    }
    if(!document.querySelector('[name="same"]').checked) {
      document.getElementById('address').style.display="none";
      document.getElementById('address-info').style.display="block";
    } else {
      document.getElementById('address').style.display="block";
      document.getElementById('address-info').style.display="none";
    }
  }

  toggleCard = () => {
    var card = document.getElementById('visa');
    var btn = document.getElementById('continue');
    card.classList.toggle('active');
    btn.classList.toggle('disabled');
    if(card.classList.contains('active')){
      this.setState({type: "active", cont: ["", "disabled"]});
    }
    else {
      this.setState({type: "", cont: ["disabled", "disabled"]});
    }
  };

  saveForm = () => {
    this.setState({cont: ["", ""]});
    if(this.state.stage === "2") {
      this.detail.name = document.querySelector('[name="name"]').value;
      this.detail.address = document.querySelector('[name="address"]').value;
      this.detail.city = document.querySelector('[name="city"]').value;
      this.detail.state = document.querySelector('[name="state"]').value;
      this.detail.country = document.querySelector('[name="country"]').value;
      this.detail.postal = document.querySelector('[name="postal"]').value;
      this.detail.phone = document.querySelector('[name="phone"]').value;
      this.detail.email = document.querySelector('[name="email"]').value;
      
      this.detail.info = "";
      if (this.detail.phone !== "") this.detail.info += ("Phone: "+this.detail.phone);
      if (this.detail.email !== "" && this.detail.phone !== "") this.detail.info += (", Email: "+this.detail.email);
      else if(this.detail.email !== "") this.detail.info += ("Email: "+this.detail.email);

      this.detail.save_address = document.querySelector('[name="save_address"]').checked;
      var copy_address = Object.assign({}, this.detail);
      addresses.push(copy_address);

    } else if(this.state.stage === "3" || this.state.stage === "7") {
      this.card.name = document.querySelector('[name="card-name"]').value;
      this.card.number = document.querySelector('[name="card-number"]').value;
      this.card.number_blocked = "•••• " + this.card.number.slice(-4);
      this.card.month = document.querySelector('[name="month"]').value;
      this.card.year = document.querySelector('[name="year"]').value;
      this.card.date = document.querySelector('[name="month"]').value+'/'+document.querySelector('[name="year"]').value.slice(-2);
      this.card.save_card = document.querySelector('[name="save_card"]').checked;
      // this.setState({saved: });
      
      var copy_card = Object.assign({}, this.card);
      cards.push(copy_card);
    }
    this.nextStage();
  };

  render() {
    var cardlist = []
    for (var i = 0; i < cards.length; i++ ) {
      if(i === cards.length-1 ) {
        cardlist.push(
          <option selected>
            <div id="payment-type"></div><p id="payment-card">{cards[i].number_blocked}, {cards[i].name}, {cards[i].date}</p>
          </option>
        );
      } else {
        cardlist.push(
          <option>
            <div id="payment-type"></div><p id="payment-card">{cards[i].number_blocked}, {cards[i].name}, {cards[i].date}</p>
          </option>
        );
      }
    };

    switch(this.state.stage){
      case "a":
        return (
          <div className="payment-type">
            <p>Choose your payment method:</p>
            <div className={this.state.type+" card"} id="visa" onClick={this.nextStage}><p>Credit/debit card</p></div>
            <div className="card" id="paypal"><p>Paypal</p></div>
            <div className="control-buttons">
              <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
              <div>
                <div id="firefox"></div><span>Firefox</span>
              </div>
              {/*<button className={this.state.cont[0]} id="continue" onClick={this.nextStage}>Continue</button>*/}
            </div>
          </div>
        );
      case "1":
        if(addresses.length !== 0) {
          if(cards.length > 1) this.setState({stage: "9"}); 
          else this.setState({stage: "6"}); 
        }
        else 
        return (
          <div className="fte-section">
            <div id="fte-images">
              <h2>Hello!</h2>
              <p>Welcome to the checkout flow powered by Firefox!</p>
              <p>This new feature will help you unify your checkout experience & check out easier and faster.</p>
            </div>
            <div className="control-buttons">
              <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
              <div>
                <div id="firefox"></div><span>Firefox</span>
              </div>
              <button id="continue" onClick={this.nextStage}>Let's Go</button>
            </div>
          </div>
        );
      case "2":
        return (
          <div className="payment-information">
            <label>Ship to:</label>
            <form name="info" noValidate autoComplete="off" action="javascript:void(0);" onSubmit={this.saveForm}>
              <input defaultValue={this.detail.name} className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="name" placeholder="Name" autofocus required />
              <input defaultValue={this.detail.address} className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="address" placeholder="Street Address" required />
              <input defaultValue={this.detail.city} className="col-6" onKeyUp={this.checkForm} type="text" name="city" placeholder="City/Town" required />
              <input defaultValue={this.detail.state} className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="state" placeholder="State/Province" required />
              <select className="input col-6" name="country" onChange={this.checkForm} required>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia, Plurinational State of</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, the Democratic Republic of the</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte dIvoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curaçao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and McDonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea, Democratic People's Republic of</option>
                <option value="KR">Korea, Republic of</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Réunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthélemy</option>
                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin (French part)</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten (Dutch part)</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">South Georgia and the South Sandwich Islands</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="United States" selected>United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela, Bolivarian Republic of</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.S.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
              <input defaultValue={this.detail.postal} className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="postal" placeholder="Postal" required />
              <input defaultValue={this.detail.phone} className="col-6" type="text" name="phone" placeholder="(Phone)" />
              <input defaultValue={this.detail.email} className="col-6 no-margin" type="text" name="email" placeholder="(Email)" />
              <input type="checkbox" defaultChecked name="save_address" /><label onClick={this.check}>Save the address to Firefox</label>
              <div className="control-buttons">
                <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
                <div>
                  <div id="firefox"></div><span>Firefox</span>
                </div>
                <div>
                  {/*<button onClick={this.prevStage}>Back</button>*/}
                  <button type="submit" className={this.state.cont[1]} id="continue">Continue</button>
                </div>
              </div>
            </form>
          </div>
        );
      case "3":
      return (
        <div className="payment-detail">
          <label>Pay by:</label>
          <div></div>
          <form name="info" noValidate autoComplete="off" action="javascript:void(0);">
            <input defaultValue={this.card.name} className="col-6" onKeyUp={this.checkForm} type="text" name="card-name" placeholder="Name on Card" autofocus required/>
            <select className="input col-3" name="month" onChange={this.checkForm} required>
                <option disabled selected> Exp. MM </option>
                <option value="01"> 01 </option>
                <option value="02"> 02 </option>
                <option value="03"> 03 </option>
                <option value="04"> 04 </option>
                <option value="05"> 05 </option>
                <option value="06"> 06 </option>
                <option value="07"> 07 </option>
                <option value="08"> 08 </option>
                <option value="09"> 09 </option>
                <option value="10"> 10 </option>
                <option value="11"> 11 </option>
                <option value="12"> 12 </option>
            </select>
            <select className="input col-3 no-margin" name="year" onChange={this.checkForm} required>
                <option disabled selected> Exp. YY </option>
                <option value="2017"> 2017 </option>
                <option value="2018"> 2018 </option>
                <option value="2019"> 2019 </option>
                <option value="2020"> 2020 </option>
                <option value="2021"> 2021 </option>
                <option value="2022"> 2022 </option>
                <option value="2023"> 2023 </option>
                <option value="2024"> 2024 </option>
                <option value="2025"> 2025 </option>
                <option value="2026"> 2026 </option>
                <option value="2027"> 2027 </option>
            </select>
            <input defaultValue={this.card.number} className="col-6" onKeyUp={this.checkForm} type="text" placeholder="Card Number" name="card-number" required/>
            <input className="col-3 no-margin" onKeyUp={this.checkForm} type="text" placeholder="CVV" required/>
            <div className="type">
              <div id="type-visa"></div><div id="type-master"></div><div id="type-express"></div>
            </div>
            <div>
              <input type="checkbox" defaultChecked name="save_card" /><label onClick={this.check}>Save the credit card to Firefox (CVV will not be saved)</label>
            </div>
          </form>
          <label>Billing Address:</label>
          <div>
            <input type="checkbox" name="same" defaultChecked onClick={this.check} /><label onClick={this.check}>Same as shipping address</label>
          </div>

          <p id="address">{this.detail.address}, {this.detail.city}, {this.detail.state}, {this.detail.country} {this.detail.postal}</p>
          <form id="address-info" name="address-info" noValidate autoComplete="off" action="javascript:void(0);" onSubmit={this.saveForm}>
              <input className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="name" placeholder="Name" required />
              <input className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="address" placeholder="Street Address" required />
              <input className="col-6" onKeyUp={this.checkForm} type="text" name="city" placeholder="City/Town" required />
              <input className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="state" placeholder="State/Province" required />
              <select className="input col-6" name="country" onChange={this.checkForm} required>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia, Plurinational State of</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, the Democratic Republic of the</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte dIvoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curaçao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and McDonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea, Democratic People's Republic of</option>
                <option value="KR">Korea, Republic of</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Réunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthélemy</option>
                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin (French part)</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten (Dutch part)</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">South Georgia and the South Sandwich Islands</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="United States" selected>United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela, Bolivarian Republic of</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.S.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
              <input className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="postal" placeholder="Postal" required />
          </form>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              <button onClick={this.prevStage}>Back</button>
              <button type="submit" className="disabled" id="continue" onClick={this.saveForm}>Preview</button>
            </div>
          </div>
        </div>
      );
      case "4":
      return (
        <div className="payment-confirmation">
          <label>Shipping Address</label>
          <div>
            <div className="col-6">
              <p>{this.detail.name}, {this.detail.address}, <br/> {this.detail.city}, {this.detail.state}, {this.detail.country} {this.detail.postal} <br/> {this.detail.info} </p>
            </div>
            <div className="col-3 add-button">+ Change Address</div>
          </div>
          <label>Payment Detail</label>
          <div>
            <div className="col-6">
              <div id="payment-type"></div><p id="payment-card">{this.card.number_blocked}, {this.card.name}, {this.card.date}</p>
            </div>
            <div className="col-3 add-button">+ Add Credit Card</div>
          </div>
          <p className="muted">*Cards and addresses are from Firefox. You can manage details in <span>Firefox options</span>.</p>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              <button onClick={this.prevStage}>Back</button>
              <button id="continue" onClick={this.props.handler}>Pay</button>
            </div>
          </div>
        </div>
      );
      case "5":
      return (null);
      case "6":
      return (
        <div className="payment-confirmation">
          <label>Shipping Address</label>
          <div>
            <div className="col-6">
              <p>{addresses[0].name}, {addresses[0].address}, <br/> {addresses[0].city}, {addresses[0].state}, {addresses[0].country} {addresses[0].postal} <br/> {addresses[0].info} </p>
            </div>
            <div className="col-3 add-button">+ Change Address</div>
          </div>
          <label>Payment Detail</label>
          <div>
            <div className="col-6">
              <div id="payment-type"></div><p id="payment-card">{cards[0].number_blocked}, {cards[0].name}, {cards[0].date}</p><input onKeyUp={this.checkCVV} name="card-cvv" className="card-cvv" type="text" placeholder="CVV" autofocus required/>
            </div>
            <div className="col-3 add-button" onClick={this.jumpStage}>+ Add Credit Card</div>
          </div>
          <p className="muted">*Cards and addresses are from Firefox. You can manage details in <span>Firefox options</span>.</p>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              {/*<button onClick={this.prevStage}>Back</button>*/}
              <button id="continue" className="disabled" onClick={this.props.handler}>Pay</button>
            </div>
          </div>
        </div>
      );
      case "7":
      return (
        <div className="payment-detail">
          <label>Pay by:</label>
          <div></div>
          <form name="info" noValidate autoComplete="off" action="javascript:void(0);">
            <input defaultValue={this.card.name} className="col-6" onKeyUp={this.checkForm} type="text" name="card-name" placeholder="Name on Card" required/>
            <select className="input col-3" name="month" onChange={this.checkForm} required>
                <option disabled selected> Exp. MM </option>
                <option value="01"> 01 </option>
                <option value="02"> 02 </option>
                <option value="03"> 03 </option>
                <option value="04"> 04 </option>
                <option value="05"> 05 </option>
                <option value="06"> 06 </option>
                <option value="07"> 07 </option>
                <option value="08"> 08 </option>
                <option value="09"> 09 </option>
                <option value="10"> 10 </option>
                <option value="11"> 11 </option>
                <option value="12"> 12 </option>
            </select>
            <select className="input col-3 no-margin" name="year" onChange={this.checkForm} required>
                <option disabled selected> Exp. YY </option>
                <option value="2017"> 2017 </option>
                <option value="2018"> 2018 </option>
                <option value="2019"> 2019 </option>
                <option value="2020"> 2020 </option>
                <option value="2021"> 2021 </option>
                <option value="2022"> 2022 </option>
                <option value="2023"> 2023 </option>
                <option value="2024"> 2024 </option>
                <option value="2025"> 2025 </option>
                <option value="2026"> 2026 </option>
                <option value="2027"> 2027 </option>
            </select>
            <input defaultValue={this.card.number} className="col-6" onKeyUp={this.checkForm} type="text" placeholder="Card Number" name="card-number" required/>
            <input className="col-3 no-margin" onKeyUp={this.checkForm} type="text" placeholder="CVV" required/>
            <div className="type">
              <div id="type-visa"></div><div id="type-master"></div><div id="type-express"></div>
            </div>
            <div>
              <input type="checkbox" defaultChecked name="save_card" /><label onClick={this.check}>Save the credit card to Firefox (CVV will not be saved)</label>
            </div>
          </form>
          <label>Billing Address:</label>
          <div>
            <input type="checkbox" name="same" defaultChecked onClick={this.check} /><label onClick={this.check}>Same as shipping address</label>
          </div>

          <p id="address">{addresses[0].name}, {addresses[0].address}, {addresses[0].city}, {addresses[0].state}, {addresses[0].country} {addresses[0].postal}</p>
          <form id="address-info" name="address-info" noValidate autoComplete="off" action="javascript:void(0);" onSubmit={this.saveForm}>
              <input className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="name" placeholder="Name" required />
              <input className="col-12 no-margin" onKeyUp={this.checkForm} type="text" name="address" placeholder="Street Address" required />
              <input className="col-6" onKeyUp={this.checkForm} type="text" name="city" placeholder="City/Town" required />
              <input className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="state" placeholder="State/Province" required />
              <select className="input col-6" name="country" onChange={this.checkForm} required>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia, Plurinational State of</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, the Democratic Republic of the</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte dIvoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curaçao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and McDonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea, Democratic People's Republic of</option>
                <option value="KR">Korea, Republic of</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Réunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthélemy</option>
                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin (French part)</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten (Dutch part)</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">South Georgia and the South Sandwich Islands</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="United States" selected>United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela, Bolivarian Republic of</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.S.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
              <input className="col-6 no-margin" onKeyUp={this.checkForm} type="text" name="postal" placeholder="Postal" required />
          </form>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              <button onClick={this.prevStage}>Back</button>
              <button type="submit" className="disabled" id="continue" onClick={this.saveForm}>Preview</button>
            </div>
          </div>
        </div>
      );
      case "8":
      return (
        <div className="payment-confirmation">
          <label>Shipping Address</label>
          <div>
            <div className="col-6">
              <p>{addresses[0].name}, {addresses[0].address}, <br/> {addresses[0].city}, {addresses[0].state}, {addresses[0].country} {addresses[0].postal} <br/> {addresses[0].info} </p>
            </div>
            <div className="col-3 add-button">+ Change Address</div>
          </div>
          <label>Payment Detail</label>
          <div>
            <div className="col-6">
              <select className="input card-dropdown" name="card-dropdown" onChange={this.checkDropdown}>
                {cardlist}
              </select>
              <input onKeyUp={this.checkCVV} className="card-cvv none" name="card-cvv" type="text" placeholder="CVV" required/>
            </div>
            <div className="col-3 add-button" onClick={this.jumpStage}>+ Add Credit Card</div>
          </div>
          <p className="muted">*Cards and addresses are from Firefox. You can manage details in <span>Firefox options</span>.</p>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              <button onClick={this.prevStage}>Back</button>
              <button id="continue" onClick={this.props.handler}>Pay</button>
            </div>
          </div>
        </div>
      );
      case "9":
      return (
        <div className="payment-confirmation">
          <label>Shipping Address</label>
          <div>
            <div className="col-6">
              <p>{addresses[0].name}, {addresses[0].address}, <br/> {addresses[0].city}, {addresses[0].state}, {addresses[0].country} {addresses[0].postal} <br/> {addresses[0].info} </p>
            </div>
            <div className="col-3 add-button">+ Change Address</div>
          </div>
          <label>Payment Detail</label>
          <div>
            <div className="col-6">
              <select className="input card-dropdown" onChange={this.cvvReset}>
                {cardlist}
              </select>
              <input onKeyUp={this.checkCVV} name="card-cvv" className="card-cvv" type="text" placeholder="CVV" autofocus required/>
            </div>
            <div className="col-3 add-button" onClick={this.jumpStage}>+ Add Credit Card</div>
          </div>
          <p className="muted">*Cards and addresses are from Firefox. You can manage details in <span>Firefox options</span>.</p>
          <div className="control-buttons">
            <button type="reset" name="cancel-button" className="no-margin cancel-button" onClick={this.closePanel}>x</button>
            <div>
              <div id="firefox"></div><span>Firefox</span>
            </div>
            <div>
              {/*<button onClick={this.prevStage}>Back</button>*/}
              <button id="continue" className="disabled" onClick={this.props.handler}>Pay</button>
            </div>
          </div>
        </div>
      );
      default:
        return true;
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js